<template>
  <div class="d-flex flex-column align-center justify-center">
    <v-img
      v-if="!noImg"
      src="@/assets/img/scrap-pile.png"
      width="100%"
      max-width="250"
      contain
      class="empty-pic flex-grow-0 mb-2"
    />

    <h4 class="text-h5 font-weight-bold mb-1">
      No loot!
    </h4>
    <p class="text-body-2 text--secondary">
      Your backpack is looking kinda empty...
    </p>

    <v-btn
      color="blue700 blue200--text"
      width="200" class="mb-2"
      tile depressed :ripple="false"
      @click="$emit('deposit')"
    >
      <fai :icon="['fab', 'steam']" class="mr-2" />
      <span class="font-weight-semibold" v-text="'Deposit items'" />
    </v-btn>

    <v-btn
      color="grey600 text--secondary"
      width="200"
      tile depressed :ripple="false"
      @click="$emit('buy')"
    >
      <fai :icon="['fad', 'box-full']" class="mr-2" />
      <span class="font-weight-semibold" v-text="'Buy items'" />
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    noImg: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
